import { render, staticRenderFns } from "./EditSensors.vue?vue&type=template&id=2b18ddd8"
import script from "./EditSensors.vue?vue&type=script&lang=js"
export * from "./EditSensors.vue?vue&type=script&lang=js"
import style0 from "./EditSensors.vue?vue&type=style&index=0&id=2b18ddd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports